<template>
  <div class="view-box columns bg-light">
    <settings-header
      button-route="new"
      :icon="icon"
      :header-title="formatedHeaderTitle"
      :button-text="$t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="showNewButton"
      :button-disabled="buttonDisabled"
    />
    <keep-alive v-if="keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>

<script>
/* eslint no-console: 0 */
import SettingsHeader from './SettingsHeader';
import { mapGetters } from 'vuex';

export default {
  components: {
    SettingsHeader,
  },
  props: {
    headerTitle: { type: String, default: '' },
    headerButtonText: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    newButtonRoutes: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    postFixCase:{type:String,required:false},
  },
  data() {
    return {
      userInboxesDetails: {},
      // buttonDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getAccount: 'accounts/getAccount',
      inboxes: 'inboxes/getInboxes',
      // agentList: 'agents/getAgents',
    }),
    currentAccount(){
      return this.getAccount(this.currentUser.account_id);
    },
    currentPage() {
      return this.$store.state.route.name;
    },
    showNewButton() {
      return this.newButtonRoutes.length !== 0 && !this.showBackButton;
    },
    formatedHeaderTitle(){
      let title = this.$t(this.headerTitle);
      switch (this.postFixCase) {
        case 'agent_lilmit':
          title += ` (${this.$t('SETTINGS.HEADER.MAX_LIMIT')}: ${this.currentAccount?.limits?.agents})`
          break;
        case 'inbox_lilmit':
          title += ` (${this.$t('SETTINGS.HEADER.MAX_LIMIT')}: ${this.currentAccount?.limits?.inboxes})`
          break;

        default:
          break;
      }
      return title;
    },
    buttonDisabled(){
      if (this.headerButtonText === 'SETTINGS.INBOXES.NEW_INBOX') {
        if (this.currentAccount?.limits?.inboxes <= this.inboxes?.length) {
          return true;
        }
      }
      return false;
    },
    // parse and combine postFix in title
  },
  // async mounted() {
  //   await this.updateDisabledButton();
  // },
  // async updated() {
  //   await this.updateDisabledButton();
  // },
  // methods: {
  //   async updateDisabledButton() {
  //     if (this.headerButtonText === 'SETTINGS.INBOXES.NEW_INBOX') {
  //       this.userInboxesDetails = await this.$store.dispatch(
  //         'accounts/fetchAccountInboxes'
  //       );
  //       this.buttonDisabled = this.userInboxesDetails.inbox_limit_reached;
  //     } else {
  //       this.buttonDisabled = false;
  //     }
  //   },
  // },

};
</script>
